import { getToken } from "./helper"
import { getStorageItem } from '../../../helpers/storageManager';

export const fetchUserDetails = async () => {
    const AuthenticationStore = getStorageItem('AuthenticationStore')
    if (!AuthenticationStore) return {}
    let user = AuthenticationStore && AuthenticationStore.user
    let token = await getToken(token => {return token})
    let mvpdProvider =  user?.tveMetadata?.mvpdProvider || null 
    let profileId=AuthenticationStore.user?.profiles?.length && AuthenticationStore.user?.profiles[0]?.profileId
    let hba = AuthenticationStore?.user?.hbaMetadata
    return {token : token, userId : user?.userId,profileId:profileId, hba, user,mvpdProvider}
} 
export const fetchUserObject = () => {
    const AuthenticationStore = getStorageItem('AuthenticationStore')
    let user = AuthenticationStore?.user
    return user
}

export const fetchMonetizationStore = async () => {
    const MonetizationStore = getStorageItem('MonetizationStore')
    return MonetizationStore
 }
export const fetchSubscriptionObject = async () => {
    const MonetizationStore = getStorageItem('MonetizationStore')
    let subscriptionData = MonetizationStore?.subscriptionData
    return subscriptionData
}

export const getUserParentalRating = () => {
  const user = fetchUserObject();
  return user?.parentalControl?.rating;
};